enum NonWorkingDays {
    NextWorkingDay = "NEXT_WORKING_DAY",
    PreviousWorkingDay = "PREVIOUS_WORKING_DAY",
    DoNotReschedule = "DO_NOT_RESCHEDULE",
}
export default NonWorkingDays